import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { T } from '../../../../../../../../Translations';
import { ExperienceResource } from '../../Types';
import OnDemandIcon from './OnDemandIcon';

export interface Props {
  resource: ExperienceResource;
}

const OnDemand: React.FC<Props> = ({ resource }) =>
  resource.payload.programInstanceOptions.onDemand
    .map(() => {
      return (
        <div className="mb-5 flex">
          <div className="mr-2 flex items-center rounded-2xl bg-gray-50 px-3 py-1 text-xs">
            <span className="mr-2">
              <OnDemandIcon />
            </span>
            <span>
              <T kind="On Demand" />
            </span>
          </div>
        </div>
      );
    })
    .getOrElse(emptyFragment);

export default observer(OnDemand);
